<div class="text-white m-auto px-6 py-12 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
        <img class="mx-auto h-20 w-auto" src="assets/images/logo/purso_white.svg" alt="{{ 'COMPANY.NAME' | translate }}">
    </div>

    <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form class="space-y-6" action="#" method="POST" (submit)="onLoginAttempt()" [formGroup]="loginForm">
            <div>
                <label for="email" class="block text-sm/6 font-medium text-white-900">{{ 'LOGIN.EMAIL_LABEL' | translate }}</label>
                <div class="mt-2">
                    <input type="email" name="email" id="email" autocomplete="email" required
                           class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300
                        placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6"
                           formControlName="email" placeholder="{{ 'LOGIN.EMAIL_PLACEHOLDER' | translate }}">
                </div>
            </div>

            <div>
                <div class="flex items-center justify-between">
                    <label for="password" class="block text-sm/6 font-medium text-white-900">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
                    <!--<div class="text-sm">
                        <a href="#" class="font-semibold text-white hover:text-secondary-300">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a>
                    </div>-->
                </div>
                <div class="mt-2">
                    <input type="password" name="password" id="password" autocomplete="current-password" required
                           class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300
                        placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6"
                           formControlName="password" placeholder="{{ 'LOGIN.PASSWORD_PLACEHOLDER' | translate }}">
                </div>
            </div>

            <div>
                <button type="submit"
                        class="flex w-full justify-center rounded-md bg-secondary px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs
                    hover:bg-secondary-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary-600">
                    {{ 'LOGIN.SIGN_IN' | translate }}
                </button>
            </div>
        </form>

        <p class="mt-10 text-center text-sm/6 text-gray-50">
            {{ 'LOGIN.NO_ACCOUNT' | translate }}
            <a [routerLink]="['/register']" class="font-semibold text-white hover:text-secondary-300">{{ 'LOGIN.REGISTER' | translate }}</a>
        </p>
    </div>
</div>
